import {BaseApiTemplateService, Core2Config} from "../../../shared";

import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { SessionThreadContainer } from "../../../../../../../models/mongodbSchema/aggregates";


@Injectable({ providedIn: 'root' })
export class SessionService extends BaseApiTemplateService<SessionThreadContainer> {

  constructor(private http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation';
    this.httpClient = http;
  }

  public setUrl(conversationId: string) {
    const baseUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation';
    this.apiUrl = `${baseUrl}/${conversationId}/threads`;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation' + `/${conversationId}/threads`;
  }

  public getUrl(): string {
    return this.apiUrl;
  }

}
